import axiosInstance from "../config/axios.config";

export const getChatNotificationsApi = (facility) => {
  return axiosInstance.get(`/chat/notifications/?facility=${facility}`);
};

export const getChatHistoryApi = (sessionId, params) => {
  return axiosInstance.get(`/chat/chat-history/${sessionId}_partner/`, {
    params,
  });
};
export const getInternalChatHistoryApi = (sessionId, params) => {
  return axiosInstance.get(`/chat/chat-history/${sessionId}_internal/`, {
    params,
  });
};

export const markChatAsReadApi = (sessionId) => {
  return axiosInstance.post(`/chat/mark-as-read/${sessionId}/`);
};
export const markInternalChatAsReadApi = (sessionId) => {
  return axiosInstance.post(`/chat/mark-as-read/${sessionId}_internal/`);
};

export const editChatApi = (sessionId, messageId, payload) => {
  return axiosInstance.patch(
    `/chat/update-message/${sessionId}/${messageId}/`,
    payload
  );
};
export const editInternalChatApi = (sessionId, messageId, payload) => {
  return axiosInstance.patch(
    `/chat/update-message/${sessionId}_internal/${messageId}/`,
    payload
  );
};

export const deleteChatApi = (sessionId, messageId) => {
  return axiosInstance.delete(
    `/chat/update-message/${sessionId}/${messageId}/`
  );
};
export const deleteInternalChatApi = (sessionId, messageId) => {
  return axiosInstance.delete(
    `/chat/update-message/${sessionId}_internal/${messageId}/`
  );
};
export const getChatGalleryApi = (admissionId, params) => {
  return axiosInstance.get(
    `/chat/chat-gallery/${admissionId}/?chat_type=${params}`
  );
};
export const getChatSessionsApi = (sessionId) => {
  return axiosInstance.get(`/chat/admission-sessions/${sessionId}/`);
};
